import { render, staticRenderFns } from "./MpnSectionTitle.vue?vue&type=template&id=fc806f90&"
import script from "./MpnSectionTitle.vue?vue&type=script&lang=js&"
export * from "./MpnSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports